import { ICustomer } from '../models';
import { getIncludedResource } from '../util';
import * as application from './application';
import * as policy from './policy';

export function fromJsonApi(data: any, included: any[] = []): ICustomer {
  const policyApplications = getIncludedResource(data, included, 'quotes', true)
    .map((item) => application.fromJsonApi(item, included));

  const policies = getIncludedResource(data, included, 'policies', true)
    .map((item) => policy.fromJsonApi(item, included));

  const renewals = getIncludedResource(data, included, 'renewals', true)
    .map((item) => application.fromJsonApi(item, included));

  return {
    id: data.id,
    title: data.attributes.title,
    firstName: data.attributes.first_name,
    lastName: data.attributes.last_name,
    companyName: data.attributes.company_name,
    customerName: data.attributes.customer_name,
    dob: data.attributes.dob,
    address: data.attributes.address,
    email: data.attributes.email,
    phone1: data.attributes.phone1,
    phone2: data.attributes.phone2,
    status: data.attributes.status,
    deceased: data.attributes.deceased,
    metadata: data.attributes.metadata,
    policyApplications,
    policies,
    renewals,
    marketingOptions: {
      email: data.attributes.marketing_options && data.attributes.marketing_options.email && true,
      sms: data.attributes.marketing_options && data.attributes.marketing_options.sms && true,
      phone: data.attributes.marketing_options && data.attributes.marketing_options.phone && true,
      post: data.attributes.marketing_options && data.attributes.marketing_options.post && true,
    },
  };
}

export function toJsonApi(customer: ICustomer) {
  const attributes: any = {
    first_name: customer.firstName,
    last_name: customer.lastName,
    address: customer.address,
    email: customer.email,
    phone1: customer.phone1,
    phone2: customer.phone2,
    password: customer.password,
    password_confirmation: customer.passwordConfirmation,
    marketing_options: {
      email: customer.marketingOptions.email && true,
      sms: customer.marketingOptions.sms && true,
      phone: customer.marketingOptions.phone && true,
      post: customer.marketingOptions.post && true,
    },
  };

  const data: any = {
    type: 'customer',
    attributes,
    relationships: {},
  };

  return data;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/data/api/transformers/customer.ts